import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function PainReactivation() {
  const painPoints = ['Semanas que empiezan sin organización', 'Correos que tardan horas en redactarse', 'Contenido que nunca termina de crearse', 'Rutinas personales que nunca se cumplen', 'Tiempo valioso que no vuelve'];
  return <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{
    once: true
  }} className="text-center" data-id="element-85">
      <h2 className="text-3xl max-sm:text-2xl md:text-5xl font-serif font-bold text-[#E8E0D0] mb-8 max-sm:mb-5 leading-tight" data-id="element-86">
        ¿Sigues perdiendo horas en tareas que la IA puede resolver en segundos?
      </h2>
      <p className="text-lg max-sm:text-base md:text-xl text-[#A09880] mb-8 max-sm:mb-5" data-id="element-87">
        Cada día que pasa sin los prompts correctos es un día más de:
      </p>
      <div className="flex flex-col gap-4 max-sm:gap-3 max-w-2xl mx-auto text-left bg-[#111111] p-8 max-sm:p-5 rounded-2xl max-sm:rounded-xl border border-[#FF3B3B]/20 shadow-[0_0_20px_rgba(255,59,59,0.05)]" data-id="element-88">
        {painPoints.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-89">
            <XCircleIcon className="w-6 h-6 max-sm:w-5 max-sm:h-5 text-[#FF3B3B] shrink-0" data-id="element-90" />
            <span className="text-lg max-sm:text-base text-[#E8E0D0]" data-id="element-91">
              {item}
            </span>
          </div>)}
      </div>
      <p className="text-xl max-sm:text-lg mt-8 max-sm:mt-5 font-medium italic text-[#A09880]" data-id="element-92">
        Y lo más doloroso de todo...
        <br data-id="element-93" />
        <br data-id="element-94" />
        <span className="text-[#D4AF37] not-italic font-serif font-bold" data-id="element-95">
          No es falta de esfuerzo. Es falta de las instrucciones correctas.
        </span>
      </p>
    </motion.div>;
}